import {
  ClockCircleOutlined,
  DeleteOutlined,
  DollarOutlined,
  EditOutlined,
  EyeOutlined,
  FieldTimeOutlined,
  HistoryOutlined,
  KeyOutlined,
  LockOutlined,
  PlusOutlined,
  SearchOutlined,
  UnlockOutlined
} from '@ant-design/icons'
import {
  Button,
  Col,
  DatePicker,
  Empty,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Tabs,
  Tag,
  Tooltip,
  Upload
} from 'antd'
import dayjs from 'dayjs'
import { debounce, isEmpty } from 'lodash'
import get from 'lodash.get'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import {
  cccdRegex,
  convertPriceToNumber,
  emailRegex,
  formatCurrencyLabel,
  hasPermission,
  passportRegex,
  passwordRegex,
  phoneRegex,
  removeUndefinedValues,
  removeVietnameseTones
} from '../../config-func'
import {
  addMoney,
  changePassword,
  departmentAll,
  departmentSearch,
  getCmsReportShowPhone,
  permissionByDepartment,
  roleSearch,
  updateStatusUser,
  userCreate,
  userDetail,
  userSearch,
  userUpdate
} from '../../services/cmsservice'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import TableField from '../common/Table/TableField'
import ChangePasswordModal from './ModalChangePassword'
import styles from './styles.module.scss'
import { PAGE_SIZE_OPTIONS } from '../../configData'
import { v4 as uuidv4 } from 'uuid'
import ModalAddMoney from './ModalAddMoney'
import ModalExtensionComunity from './ModalExtensionComunity'
import { pakageCommunityExtension } from '../../services/pakage-community-service'
import { upLoadImagePrivate } from '../../services/postservice'
import Loading from '../Loading'
const { Option } = Select
export const ACTION_MODE = {
  VIEW: 'VIEW',
  ADD: 'ADD',
  UPDATE: 'UPDATE'
}
const layout = {
  // labelCol: {
  //   span: 11
  // },
  wrapperCol: {
    span: 24
  }
}

const OPTIONS_ROLE = [
  {
    value: 'CEO',
    name: 'CEO'
  },
  {
    value: 'DIRECTOR',
    name: 'Giám đốc'
  },
  {
    value: 'SALE_MANAGER',
    name: 'Quản lý sản phẩm'
  },
  {
    value: 'SALE',
    name: 'Nhân viên'
  },
  {
    value: 'CUSTOMER',
    name: 'Khách hàng'
  },
  {
    value: 'COLLAB',
    name: 'Cộng tác viên'
  },
  {
    value: 'SUB_ADMIN',
    name: 'Sub Admin'
  }
]

const OPTIONS_PRODUCT_TYPE = [
  {
    value: 'ALL',
    name: 'Tất cả'
  },
  {
    value: 'SELL',
    name: 'Bán'
  },
  {
    value: 'RENT',
    name: 'Thuê'
  }
]

const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)
const UserManagement = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [form] = Form.useForm()
  const [formSearch] = Form.useForm()
  const [isModalOpen, setIsModalOpen] = useState(false)
  // const [pageSize, setPageSize] = useState(10) // Kích thước trang mặc định
  // const [page, setCurrentPage] = useState(1) // Trang hiện tại
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [listUser, setListUser] = useState([])
  const [listDepartment, setListDepartment] = useState([])
  const [listDepartmentAll, setListDepartmentAll] = useState([])
  const [listRole, setListRole] = useState([])
  const [visibleChangePass, setVisibleChangePass] = useState(false)
  const [visibleChangeMoney, setVisibleMoney] = useState(false)
  const [visibleExtension, setVisibleExtension] = useState(false)
  const [detailUser, setDetailUser] = useState()
  const [loading, setLoading] = useState(false)
  const [fileFront, setFileFront] = useState([])
  const [fileBack, setFileBack] = useState([])
  const [currentFrontImage, setCurrentFrontImage] = useState('')
  const [currentBackImage, setCurrentBackImage] = useState('')
  const [previewVisible, setPreviewVisible] = useState(false)
  const [previewImage, setPreviewImage] = useState('')
  const [previewTitle, setPreviewTitle] = useState('')
  const [visibleShowPhoneHistory, setVisibleShowPhoneHistory] = useState(false)
  const [showPhoneHistoryUser, setShowPhoneHistoryUser] = useState(null)
  const [showPhoneHistoryLoading, setShowPhoneHistoryLoading] = useState(false)
  const [showPhoneHistoryDate, setShowPhoneHistoryDate] = useState([
    dayjs().subtract(1, 'month').startOf('month'),
    dayjs().endOf('day')
  ])
  const [showPhoneHistoryData, setShowPhoneHistoryData] = useState({
    posts: [],
    requests: [],
    customerData: [],
    recruiment: []
  })
  const userRole = Form.useWatch('user_role', form)
  const isMobile = window.innerWidth < 768
  const [departmentField, setDepartmentField] = useState({
    name: 'department',
    mode: undefined // Không multiple
  })

  const deId = localStorage.getItem('department_id')
  const userRo = localStorage.getItem('user_role')

  const renderTimestamp = (value) =>
    value ? dayjs(Number(value) * 1000).format('DD/MM/YYYY HH:mm:ss') : ''

  const renderDateTime = (value) =>
    value ? dayjs(value).format('DD/MM/YYYY HH:mm:ss') : ''

  const renderHistoryUserInfo = (_, record) => {
    const name = showPhoneHistoryUser?.name || ''
    const email = showPhoneHistoryUser?.email || ''
    const userId = record?.user_id || showPhoneHistoryUser?.id || ''
    return [name, email, userId].filter(Boolean).join(' - ')
  }

  const showPhoneHistoryColumns = {
    posts: [
      // { title: 'ID', dataIndex: 'id', key: 'id', width: 90 },
      { title: 'Mã tin', dataIndex: 'post_id', key: 'post_id', width: 120 },
      {
        title: 'User ID',
        dataIndex: 'user_id',
        key: 'user_id',
        width: 260,
        render: renderHistoryUserInfo
      },
      {
        title: 'Thời gian',
        dataIndex: 'created_at',
        key: 'created_at',
        width: 180,
        render: renderTimestamp
      }
    ],
    requests: [
      // { title: 'ID', dataIndex: 'id', key: 'id', width: 90 },
      {
        title: 'Mã yêu cầu',
        dataIndex: 'request_id',
        key: 'request_id',
        width: 120
      },
      {
        title: 'User ID',
        dataIndex: 'user_id',
        key: 'user_id',
        width: 260,
        render: renderHistoryUserInfo
      },
      {
        title: 'Thời gian',
        dataIndex: 'created_at',
        key: 'created_at',
        width: 180,
        render: renderTimestamp
      }
    ],
    customerData: [
      // { title: 'ID', dataIndex: 'id', key: 'id', width: 90 },
      {
        title: 'Mã data',
        dataIndex: 'customer_data_id',
        key: 'customer_data_id',
        width: 120,
        render: (_, record) =>
          record?.customer_data_id || record?.customerData_id || record?.data_id || ''
      },
      {
        title: 'User ID',
        dataIndex: 'user_id',
        key: 'user_id',
        width: 260,
        render: renderHistoryUserInfo
      },
      {
        title: 'Thời gian',
        dataIndex: 'created_at',
        key: 'created_at',
        width: 180,
        render: renderDateTime
      }
    ],
    recruiment: [
      // { title: 'ID', dataIndex: 'id', key: 'id', width: 90 },
      {
        title: 'Mã tin tuyển dụng',
        dataIndex: 'customer_data_id',
        key: 'customer_data_id',
        width: 130,
        render: (_, record) =>
          record?.customer_data_id || record?.customer_data_id || ''
      },
      {
        title: 'User ID',
        dataIndex: 'user_id',
        key: 'user_id',
        width: 260,
        render: renderHistoryUserInfo
      },
      {
        title: 'Thời gian',
        dataIndex: 'created_at',
        key: 'created_at',
        width: 180,
        render: renderDateTime
      }
    ]
  }

  const [pagination, setPagination] = useState({
    current: 1, // Trang hiện tại
    pageSize: 10,
    reset: 0 // Số bản ghi mỗi trang
  })

  const fetchShowPhoneHistory = async (user, dateRange = showPhoneHistoryDate) => {
    if (!user?.id) return
    if (!dateRange?.[0] || !dateRange?.[1]) {
      openNotification('error', 'Vui lòng chọn khoảng ngày')
      return
    }

    setShowPhoneHistoryLoading(true)
    try {
      const response = await getCmsReportShowPhone({
        // page: 1,
        // pageSize: 10,
        start_date: dayjs(dateRange[0]).startOf('day').unix(),
        end_date: dayjs(dateRange[1]).endOf('day').unix(),
        user_id: user.id,
      })
      const data = response?.data || {}
      setShowPhoneHistoryData({
        posts: data?.posts || data?.postHistory || [],
        requests: data?.requests || data?.requestHistory || [],
        customerData: data?.customerData || [],
        recruiment: data?.recruiment || data?.recruitment || []
      })
    } catch (error) {
      openNotification(
        'error',
        error?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setShowPhoneHistoryLoading(false)
    }
  }

  const openShowPhoneHistory = (record) => {
    const defaultDate = [
      dayjs().subtract(1, 'month').startOf('month'),
      dayjs().endOf('day')
    ]
    setShowPhoneHistoryUser(record)
    setShowPhoneHistoryDate(defaultDate)
    setShowPhoneHistoryData({
      posts: [],
      requests: [],
      customerData: [],
      recruiment: []
    })
    setVisibleShowPhoneHistory(true)
    fetchShowPhoneHistory(record, defaultDate)
  }

  const getUserAll = async (values) => {
    const {
      search = '',
      role = '',
      department = '',
      status = '',
      user_role = '',
      page = 1,
      type_role = '',
      pageSize = pagination.pageSize || 10
    } = values || {}

    setLoading(true)
    try {
      const body = {
        search: search.trim(),
        role: user_role,
        // user_role,
        department: userRo == 'ADMIN' ? department : deId,
        status,
        type_role,
        page,
        pageSize
      }
      const res = await userSearch(body) // Assuming roleSearch is an API function

      if (res && res.data) {
        setListUser(res.data) // Update the state with the list of roles
      } else {
        // Handle the case where the response is unexpected or empty
        console.error('No data found or invalid response')
        setListUser([]) // Optionally, reset the list to an empty array
      }
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
      setListUser([]) // Optionally, reset the list to an empty array
    } finally {
      setLoading(false)
    }
  }
  const getDepartment = async (id) => {
    try {
      const body = { pageSize: 1000, department_id: id }
      const res = await departmentSearch(body)
      setListDepartment(res.data)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  const getDepartmentAll = async () => {
    try {
      const body = { pageSize: 1000 }
      const res = await departmentAll(body)
      setListDepartmentAll(res.data)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  useEffect(() => {
    if (userRo == 'ADMIN') {
      getDepartment()
    } else {
      getDepartment(deId)
    }
  }, [deId, userRo])

  useEffect(() => {
    getDepartmentAll()
  }, [])
  const handleSearch = debounce((values) => {
    return values
  }, 300)

  // Debounced function for form change handler
  // const debouncedFormChange = useCallback(
  //   debounce((changedValues, allValues) => {
  //     console.log('Debounced Changed Values:', changedValues)
  //     console.log('Debounced All Values:', allValues)
  //     setCurrentPage(1)
  //     getUserAll(allValues)
  //   }, 500), // 500ms debounce delay
  //   []
  // )

  useMemo(() => {
    const value = formSearch.getFieldsValue()
    getUserAll({
      ...value,
      page: pagination.current,
      pageSize: pagination.pageSize
    })
  }, [pagination, userRo])

  const debouncedFormChange = useCallback(
    debounce(() => {
      const allValues = formSearch.getFieldsValue() // Lấy tất cả giá trị từ form
      // getUserAll({
      //   ...allValues, // Truyền toàn bộ giá trị form
      //   page: 1, // Giữ nguyên trang hiện tại
      //   pageSize: pagination.pageSize // Giữ nguyên số lượng item mỗi trang
      // })
      setPagination((prev) => ({
        ...prev,
        ...allValues,
        current: 1
      }))
    }, 300),

    [formSearch, pagination.current, pagination.pageSize]
  )

  // Form change handler with debounce
  const handleFormChange = (changedValues, allValues) => {
    debouncedFormChange(changedValues, allValues)
  }

  const handleCustomRequest = async (options) => {
    const { file, onSuccess, onError, onProgress } = options
    const formData = new FormData()
    formData.append('file_image', file)
    try {
      const response = await upLoadImagePrivate(formData)
      if (onProgress) {
        onProgress({ percent: 100 })
      }
      onSuccess(response.data, file)
    } catch (error) {
      onError(error)
      openNotification('error', 'Upload thất bại')
    }
  }

  const handlePreview = async (file) => {
    if (file.response) {
      setPreviewImage(file.response?.[0]?.link)
    } else {
      setPreviewImage(file.url)
    }
    setPreviewVisible(true)
    setPreviewTitle(false)
  }

  const handleChangeFront = (info) => {
    let newFileList = [...info.fileList]
    newFileList = newFileList.filter((file) => {
      if (file.status == 'error') {
        openNotification('error', `Upload thất bại: ${file.name}`)
      }
      return file.status !== 'error'
    })
    setFileFront(newFileList)
  }

  const handleChangeBack = (info) => {
    let newFileList = [...info.fileList]
    newFileList = newFileList.filter((file) => {
      if (file.status == 'error') {
        openNotification('error', `Upload thất bại: ${file.name}`)
      }
      return file.status !== 'error'
    })
    setFileBack(newFileList)
  }

  const UploadButton = () => {
    return (
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    )
  }

  const handleSave = async () => {
    setLoading(true)
    try {
      // Validate các trường trong form
      const values = await form.validateFields()
      // Kiểm tra nếu cả hai giá trị đều tồn tại
      // Lọc ra các key có giá trị true và đưa vào mảng
      const { front_image, back_image, ...restValues } = values
      const dep = values.user_role == 'CEO' ? 'department_manage' : 'department'
      // Only use newly uploaded files from response when user changes images.
      // Keep snake_case fields in request body as required by BE.
      const frontImage = fileFront?.[0]?.response?.[0]?.link
      const backImage = fileBack?.[0]?.response?.[0]?.link
      const body = {
        ...restValues,
        [dep]:
          values.user_role == 'CEO'
            ? values.department_manage
            : values.department
      }
      if (frontImage) {
        body.front_image = frontImage
      } else if (mode === ACTION_MODE.UPDATE && currentFrontImage) {
        body.front_image = currentFrontImage
      }
      if (backImage) {
        body.back_image = backImage
      } else if (mode === ACTION_MODE.UPDATE && currentBackImage) {
        body.back_image = currentBackImage
      }

      const res =
        mode == ACTION_MODE.ADD
          ? await userCreate(body)
          : await userUpdate(body, values.id)
      form.resetFields()
      setIsModalOpen(false)
      setFileFront([])
      setFileBack([])
      setCurrentFrontImage('')
      setCurrentBackImage('')
      const value = formSearch.getFieldsValue()
      getUserAll({
        ...value,
        page: pagination.current,
        pageSize: pagination.pageSize
      })
      if (res) {
        openNotification(
          'success',
          mode == ACTION_MODE.ADD
            ? 'Thêm mới tài khoản thành công'
            : 'Cập nhật tài khoản thành công'
        )
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)

      console.error('Error creating product:', err)
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }
  const updateStatus = async (status, id) => {
    setLoading(true)
    try {
      const res = await updateStatusUser(status, id)
      const value = formSearch.getFieldsValue()
      getUserAll({
        ...value,
        page: pagination.current,
        pageSize: pagination.pageSize
      })
      openNotification('success', res.message)
      setLoading(false)
    } catch (err) {
      setLoading(false)

      console.error('Error creating product:', err)
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }

  const getDetailUser = async (id) => {
    setLoading(true)
    try {
      const res = await userDetail(id) // Assuming roleSearch is an API function

      if (res && res.data) {
        setIsModalOpen(true)
        const values = res.data

        if (values.user_role == 'CEO') {
          setDepartmentField({
            name: 'department_manage',
            mode: 'multiple'
          })
        } else {
          setDepartmentField({
            name: 'department',
            mode: ''
          })
        }
        // const p = values.user_department_info?.[0]?.department_id
        form.setFieldsValue({
          ...values,
          date_of_birth: values.date_of_birth
            ? dayjs(values.date_of_birth)
            : values.date_of_birth,
          department: values.department_id || '',
          department_manage: values?.department_manage
            ? values.department_manage
            : [],
          productType: values.product_type,
          permission_id: Number(values?.permission_id)
        })

        if (values.department_id) {
          getPermissionByDepartment(values.department_id)
        } else if (values.user_role == 'CUSTOMER') {
          getPermissionByDepartment('')
        }
        // Use camelCase for displaying preview in edit modal.
        const frontImageDetail = values?.frontImage || ''
        const backImageDetail = values?.backImage || ''
        // Keep snake_case values for payload fallback when user does not re-upload.
        setCurrentFrontImage(values?.front_image || '')
        setCurrentBackImage(values?.back_image || '')
        setFileFront(
          frontImageDetail
            ? [
                {
                  uid: 'front_image',
                  name: 'Ảnh mặt trước',
                  status: 'done',
                  url: frontImageDetail
                }
              ]
            : []
        )
        setFileBack(
          backImageDetail
            ? [
                {
                  uid: 'back_image',
                  name: 'Ảnh mặt sau',
                  status: 'done',
                  url: backImageDetail
                }
              ]
            : []
        )
        setLoading(false)
      } else {
        console.error('No data found or invalid response')
      }
    } catch (err) {
      setLoading(false)

      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  const getPermissionByDepartment = async (id) => {
    try {
      const res = await permissionByDepartment(id)

      if (res && res.data) {
        setListRole(res.data.list) // Update the state with the list of roles
      } else {
        // Handle the case where the response is unexpected or empty
        console.error('No data found or invalid response')
        setListRole([]) // Optionally, reset the list to an empty array
      }
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
      setListRole([]) // Optionally, reset the list to an empty array
    }
  }

  const validateConfirmPassword = (_, value) => {
    if (!value || form.getFieldValue('password') === value) {
      return Promise.resolve()
    }
    return Promise.reject(new Error('Mật khẩu nhập lại không trùng khớp!'))
  }

  const handleChangePassword = async (values) => {
    setLoading(true)
    const body = {
      password: values.password
    }
    try {
      const res = await changePassword(body, detailUser.id)
      openNotification('success', res.message)
      setVisibleChangePass(false)
      setLoading(false)
    } catch (err) {
      setLoading(false)

      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }

  const onPaymentPackage = async (values) => {
    setLoading(true)
    const body = {
      type: 1,
      pakage_community_id: values.type,
      user_id: detailUser.id
    }
    try {
      const res = await pakageCommunityExtension(body)
      openNotification('success', res.message)
      setVisibleExtension(false)
      const value = formSearch.getFieldsValue()
      getUserAll({
        ...value,
        page: pagination.current,
        pageSize: pagination.pageSize
      })
      setLoading(false)
    } catch (err) {
      setLoading(false)

      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }
  const onAddMoney = async (values) => {
    setLoading
    const body = {
      ...values,
      user_id: detailUser.id,
      amount: convertPriceToNumber(values.amount?.toString())
    }
    try {
      const res = await addMoney(body)
      if (res.message == 'Deposit success') {
        openNotification(
          'success',
          values.type == 'ADD'
            ? 'Thêm tiền vào tài khoản thành công'
            : 'Thu hồi tiền tài khoản thành công'
        )
        setVisibleMoney(false)
        const value = formSearch.getFieldsValue()
        getUserAll({
          ...value,
          page: pagination.current,
          pageSize: pagination.pageSize
        })
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)

      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }

  const handlePageChange = (current, pageSize) => {
    setPagination((prev) => ({
      ...prev,
      current: prev.pageSize !== pageSize ? 1 : current, // Nếu đổi pageSize thì reset current
      pageSize
    }))
  }

  const handleReset = debounce(() => {
    formSearch.resetFields()
    // getUserAll()
    setPagination((prev) => ({
      current: 1, // Nếu đổi pageSize thì reset current
      pageSize: 10,
      reset: uuidv4()
    }))
  }, 300)

  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: isMobile ? false : 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1
    },
    { title: 'ID', dataIndex: 'id', key: 'id', align: 'center', width: 60 },
    { title: 'Họ tên', dataIndex: 'name', key: 'name', width: 150 },
    {
      title: 'Sàn',
      dataIndex: 'department_id',
      key: 'department_id',
      width: 150,
      render: (_, record) => {
        if (!listDepartmentAll?.list) return null

        if (!isEmpty(record?.department_manage)) {
          const raw = record?.department_manage

          const departmentIds = Array.isArray(raw)
            ? raw.map(Number)
            : typeof raw === 'string'
            ? raw.split(',').map((id) => Number(id.trim()))
            : []

          const departmentNames = departmentIds
            .map((id) => listDepartmentAll.list.find((n) => n.id === id)?.name)
            .filter(Boolean)
          return (
            <div
              style={{
                maxWidth: 200,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word'
              }}
            >
              {departmentNames?.join(',\n')}
            </div>
          )
        } else {
          return (
            <span>
              {record?.department_info?.name}
              {/* {listDepartmentAll.list.find((n) => n.id === record.department_id)?.name || ''} */}
            </span>
          )
        }
      }
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: 150
      // fixed: isMobile ? 'left' : false
    },
    { title: 'Số điện thoại', dataIndex: 'phone', key: 'phone', width: 120 },
    {
      title: 'Chức danh',
      dataIndex: 'user_role',
      key: 'user_role',
      width: 150,
      render: (_, record) => {
        const item = OPTIONS_ROLE.find((i) => i.value == record.user_role)
        return item?.name ? item.name : record.user_role
      }
    },
    {
      title: 'Loại quyền',
      dataIndex: 'type_role',
      key: 'type_role',
      width: 150,
      render: (_, record) => {
        return <p>{record?.permission_info?.type || ''}</p>
      }
    },
    {
      title: 'Ngày sinh',
      dataIndex: 'date_of_birth',
      key: 'date_of_birth',
      width: 150,
      render: (text) => {
        return <span>{text && dayjs(text).format('DD/MM/YYYY')}</span>
      }
    },
    {
      title: 'Số CCCD',
      dataIndex: 'identification_number',
      key: 'identification_number',
      width: 150
    },
    {
      title: 'TK chính',
      dataIndex: 'main_account',
      key: 'main_account',
      width: 150,
      render: (_, record) => {
        return (
          <span>
            {formatCurrencyLabel(record?.user_account_info?.main_account)}
          </span>
        )
      }
    },
    {
      title: 'TK khuyến mãi',
      dataIndex: 'promotion_account',
      key: 'promotion_account',
      width: 150,
      render: (_, record) => {
        return (
          <span>
            {formatCurrencyLabel(record?.user_account_info?.promotion_account)}
          </span>
        )
      }
    },
    {
      title: 'TK tích luỹ',
      dataIndex: 'total_spent_amount',
      key: 'total_spent_amount',
      width: 150,
      render: (_, record) => {
        return (
          <span>
            {formatCurrencyLabel(record?.user_account_info?.total_spent_amount)}
          </span>
        )
      }
    },
    {
      title: 'Ngày đăng ký',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 150,
      render: (text) => {
        return <span>{text && dayjs(text * 1000).format('DD/MM/YYYY')}</span>
      }
    },

    {
      title: 'Ngày hết hạn',
      dataIndex: 'date_end_communi',
      key: 'date_end_communi',
      width: 150,
      render: (text, record) => {
        return (
          <span>
            {record.user_account_info?.date_end_communi &&
              dayjs(record.user_account_info?.date_end_communi).format(
                'DD/MM/YYYY'
              )}
          </span>
        )
      }
    },

    {
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'type',
      width: 150,
      render: (text) => {
        if (text === 'active') {
          return <Tag color="green">Hoạt động</Tag>
        } else if (text === 'inactive') {
          return <Tag color="red">Ngừng hoạt động</Tag>
        }
      }
    },
    {
      title: 'Hành động',
      key: 'status',
      fixed: isMobile ? false : 'right',
      width: 150,
      render: (_, record) => {
        return (
          <Space size="small">
            {record.status !== 'delete' && (
              <>
                {hasPermission('P42.2', permissions) && (
                  <Tooltip title="Chỉnh sửa">
                    <Button
                      style={{ width: 32 }}
                      icon={<EditOutlined />}
                      onClick={() => {
                        setMode(ACTION_MODE.UPDATE)
                        getDetailUser(record.id)
                      }}
                    />
                  </Tooltip>
                )}
                {hasPermission('P42.3', permissions) && (
                  <Tooltip title="Đổi mật khẩu">
                    <Button
                      style={{ width: 32 }}
                      icon={<KeyOutlined />}
                      onClick={() => {
                        setVisibleChangePass(true)
                        setDetailUser(record)
                      }}
                    />
                  </Tooltip>
                )}
                {hasPermission('P42.4', permissions) && (
                  <Tooltip
                    title={
                      record.status == 'inactive'
                        ? 'Mở khoá tài khoản'
                        : 'Khoá tài khoản'
                    }
                  >
                    <Button
                      style={{ width: 32 }}
                      icon={
                        record.status == 'inactive' ? (
                          <LockOutlined style={{ color: 'red' }} />
                        ) : (
                          <UnlockOutlined style={{ color: 'green' }} />
                        )
                      }
                      // icon={<LockOutlined />}
                      onClick={() =>
                        showConfirm({
                          title: `${
                            record.status == 'active' ? 'Khoá' : 'Mở khoá'
                          } tài khoản`,
                          content: (
                            <div>
                              Bạn có chắc chắn muốn{' '}
                              {record.status == 'active' ? 'khoá' : 'mở khoá'}{' '}
                              tài khoản
                              <b> {record.name}</b> không?
                            </div>
                          ),
                          onOk: () =>
                            updateStatus(
                              record.status == 'inactive'
                                ? 'active'
                                : 'inactive',
                              record.id
                            )
                        })
                      }
                      // onClick={() => setVisibleChangePass(true)}
                    />
                  </Tooltip>
                )}
                {hasPermission('P42.5', permissions) && (
                  <Tooltip title="Thêm tiền/Thu hồi tiền tài khoản">
                    <Button
                      style={{ width: 32 }}
                      icon={<DollarOutlined />}
                      onClick={() => {
                        setVisibleMoney(true)
                        setDetailUser(record)
                      }}
                    />
                  </Tooltip>
                )}
                {hasPermission('P42.7', permissions) && (
                  <Tooltip title="Gia hạn cộng đồng">
                    <Button
                      style={{ width: 32 }}
                      icon={<ClockCircleOutlined />}
                      onClick={() => {
                        setVisibleExtension(true)
                        setDetailUser(record)
                      }}
                    />
                  </Tooltip>
                )}
                <Tooltip title="Xem lịch sử xem số điện thoại">
                  <Button
                    style={{ width: 32 }}
                    icon={<HistoryOutlined />}
                    onClick={() => openShowPhoneHistory(record)}
                  />
                </Tooltip>
                {hasPermission('P42.6', permissions) && (
                  <Tooltip title="Xóa tài khoản">
                    <Button
                      style={{ width: 32 }}
                      icon={<DeleteOutlined style={{ color: 'red' }} />}
                      onClick={() =>
                        showConfirm({
                          title: 'Xóa tài khoản',
                          content: (
                            <div>
                              Bạn có chắc chắn muốn xóa tài khoản
                              <b> {record.name}</b> không?
                            </div>
                          ),
                          type: 'error',
                          onOk: () => updateStatus('delete', record.id)
                          // onOk: () => deleteUser(record)
                        })
                      }
                    />
                  </Tooltip>
                )}
              </>

              // <DeleteOutlined
              //   onClick={() =>
              //     showConfirm({
              //       title: 'Xóa tài khoản',
              //       content: (
              //         <div>
              //           Bạn có chắc chắn muốn xóa tài khoản
              //           <b> {record.name}</b> không?
              //         </div>
              //       )
              //       // onOk: () => deleteUser(record)
              //     })
              //   }
              //   style={{ fontSize: '16px', color: 'red', cursor: 'pointer' }}
              // />
            )}
            {/* <Button type="primary">Chi tiết</Button>
              <Button danger>Xóa</Button> */}
          </Space>
        )
      }
    }
  ]

  return (
    <div>
      <Loading loading={loading} />
      <Card className="pt-4 mb-2">
        <Form
          form={formSearch}
          // onValuesChange={handleFormChange}
          layout="vertical"
          onFinish={debouncedFormChange}
          labelCol={{ span: 24 }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              alignItems: 'center'
            }}
          >
            {/* Ô tìm kiếm */}
            <Form.Item
              label="ID, Mã nhân viên, Họ tên, Email, SĐT"
              name="search"
              className={styles.formItem}
            >
              <Input
                prefix={<SearchOutlined />}
                placeholder="Nhập mã nhân viên, họ tên, email, số điện thoại"
                onBlur={(e) => {
                  formSearch.setFields([
                    {
                      name: 'search',
                      value: e.target.value?.trim()
                    }
                  ])
                }}
              />
            </Form.Item>
            {/* <Form.Item
              label="Sàn"
              name="department"
              labelCol={{ span: 8 }}
              className={styles.formItem}
            >
              <Select defaultValue="Tất cả">
                <Option value="">Tất cả</Option>
                {listDepartment?.list?.map((item, idx) => {
                  return (
                    <Option key={idx} value={item.id}>
                      {item.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item> */}
            <Form.Item
              name={'department'}
              label="Sàn"
              labelCol={{ span: 8 }}
              className={styles.formItem}
            >
              <Select
                style={{ width: '100%' }}
                placeholder="Chọn sàn"
                allowClear
                // mode={departmentField.mode}
                defaultValue="Tất cả"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const inputValue = removeVietnameseTones(input).toLowerCase()
                  const optionValue = removeVietnameseTones(
                    option?.children || ''
                  ).toLowerCase()
                  return optionValue.includes(inputValue)
                }}
              >
                <Option value="">Tất cả</Option>
                {listDepartment?.list?.map((item, idx) => (
                  <Option key={idx} value={item.id}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Chức danh"
              name="user_role"
              labelCol={{ span: 8 }}
              className={styles.formItem}
            >
              <Select
                defaultValue="Tất cả"
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const inputValue = removeVietnameseTones(input).toLowerCase()
                  const optionValue = removeVietnameseTones(
                    option?.children || ''
                  ).toLowerCase()
                  return optionValue.includes(inputValue)
                }}
              >
                <Option value="">Tất cả</Option>
                {OPTIONS_ROLE.map((item, idx) => {
                  return (
                    <Option key={idx} value={item.value}>
                      {item.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
            {/* Dropdown Trạng thái (rộng hơn) */}
            <Form.Item
              label="Trạng thái"
              name="status"
              labelCol={{ span: 8 }}
              className={styles.formItem}
            >
              <Select
                defaultValue="Tất cả"
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const inputValue = removeVietnameseTones(input).toLowerCase()
                  const optionValue = removeVietnameseTones(
                    option?.children || ''
                  ).toLowerCase()
                  return optionValue.includes(inputValue)
                }}
              >
                <Option value="">Tất cả</Option>
                <Option value="active">Hoạt động</Option>
                <Option value="inactive">Ngừng hoạt động</Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="Loại quyền"
              name="type_role"
              labelCol={{ span: 8 }}
              className={styles.formItem}
            >
              <Select
                defaultValue="Tất cả"
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const inputValue = removeVietnameseTones(input).toLowerCase()
                  const optionValue = removeVietnameseTones(
                    option?.children || ''
                  ).toLowerCase()
                  return optionValue.includes(inputValue)
                }}
              >
                <Option value="">Tất cả</Option>
                <Option value="APP">APP</Option>
                <Option value="CMS">CMS</Option>
              </Select>
            </Form.Item>
          </div>
          <div
            className={styles.formItem}
            style={{ textAlign: 'right', marginTop: 6 }}
          >
            <Button onClick={handleReset}>Đặt lại</Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{ margin: '0 8px' }}
            >
              Tìm kiếm
            </Button>
          </div>
        </Form>
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {/* <h2 className="text-2xl font-semibold my-2">Danh sách tài khoản</h2> */}
          {hasPermission('P42.1', permissions) && (
            <Button
              type="primary"
              // htmlType="submit"
              onClick={() => {
                setIsModalOpen(true)
                setMode(ACTION_MODE.ADD)
                setFileFront([])
                setFileBack([])
                setCurrentFrontImage('')
                setCurrentBackImage('')
                form.setFieldsValue({
                  front_image: undefined,
                  back_image: undefined
                })
              }}
            >
              <PlusOutlined />
              Thêm mới
            </Button>
          )}
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          data={listUser?.list}
          scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: listUser?.total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            // onShowSizeChange: (current, size) => {
            //   setPageSize(size) // Cập nhật lại kích thước trang
            //   setCurrentPage(1) // Reset lại trang khi thay đổi kích thước trang
            // },
            onChange: handlePageChange,
            showTotal: (total, range) =>
              `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`
            // onChange: (page) => {
            //   setCurrentPage(page) // Cập nhật trang khi người dùng thay đổi trang
            //   getUserAll({ page: page })
            // }
          }}
          rowKey={(record, index) => index}
          locale={{
            emptyText: <Empty description="Không có dữ liệu" />, // Hiển thị "Không có dữ liệu" khi bảng không có dữ liệu
            triggerDesc: 'Sắp xếp giảm dần', // Khi click vào cột để sort giảm dần
            triggerAsc: 'Sắp xếp tăng dần', // Khi click vào cột để sort tăng dần
            cancelSort: 'Hủy sắp xếp' // Khi bỏ sắp xếp
          }}
        />
      </Card>
      {/* Modal Thêm mới sản phẩm */}
      <ModalCustom
        title={
          mode == ACTION_MODE.UPDATE
            ? 'Chỉnh sửa tài khoản'
            : 'Thêm mới tài khoản'
        }
        visible={isModalOpen}
        centered
        // width={1200}
        // className="modal-bond"
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()

          // }
          //   setFileList([])
          setFileFront([])
          setFileBack([])
          setCurrentFrontImage('')
          setCurrentBackImage('')
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            console.log('Validation failed:', error)
            if (error?.errorFields?.length > 0) {
              form.scrollToField(error.errorFields[0].name, {
                behavior: 'smooth',
                block: 'center' // Đảm bảo label không bị che
              })
            }
          }
        }}
        confirmText={mode == ACTION_MODE.ADD ? 'Thêm mới' : 'Cập nhật'}
        cancelText="Huỷ"
      >
        <Form
          // variant={'filled'}
          // labelWrap
          requiredMark={customizeRequiredMark}
          labelAlign="left"
          labelCol={{ span: 8 }}
          form={form}
          layout="horizontal"
          style={{
            // maxHeight: '80vh',
            overflow: 'auto',
            overflowX: 'hidden',
            padding: '0px 10px'
          }}
          autoComplete="off"
          inputMode="none"
          {...layout}
          // initialValues={{
          //   password: '',
          //   re_enter_password: ''
          // }}
        >
          <Form.Item name="id" label="" style={{ display: 'none' }}>
            <Input></Input>
          </Form.Item>
          <Form.Item
            name="name"
            label="Họ tên"
            rules={[
              {
                message: 'Vui lòng nhập họ tên',
                required: true
              }
            ]}
          >
            <Input
              placeholder="Nhập họ tên"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'name',
                    value: e.target.value?.trim()
                  }
                ])
              }}
              autoComplete="off"
              inputMode="none"
            />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: 'Vui lòng nhập email!' },
              { pattern: emailRegex, message: 'Email không hợp lệ!' }
            ]}
          >
            <Input
              placeholder="Nhập email"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'email',
                    value: e.target.value?.trim()
                  }
                ])
              }}
              autoComplete="off"
              inputMode="none"
            />
          </Form.Item>
          <Form.Item
            label="Điện thoại"
            name="phone"
            rules={[
              { required: true, message: 'Vui lòng nhập số điện thoại!' },
              { pattern: phoneRegex, message: 'Số điện thoại không hợp lệ!' }
            ]}
          >
            <Input
              placeholder="Nhập số điện thoại"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'phone',
                    value: e.target.value?.trim()
                  }
                ])
              }}
              autoComplete="off"
              inputMode="none"
            />
          </Form.Item>
          <div style={{ fontWeight: 600, margin: '16px 0 8px' }}>
            Giấy tờ tuỳ thân
          </div>
          <Row gutter={32} justify="end">
            <Col xs={24} md={12}>
              <Form.Item
                label="Ảnh mặt trước"
                name="front_image"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Upload
                  accept="image/*"
                  customRequest={handleCustomRequest}
                  onChange={handleChangeFront}
                  listType="picture-card"
                  fileList={fileFront}
                  onPreview={handlePreview}
                  maxCount={1}
                >
                  {fileFront.length < 1 && <UploadButton />}
                </Upload>
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Ảnh mặt sau"
                name="back_image"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Upload
                  accept="image/*"
                  customRequest={handleCustomRequest}
                  onChange={handleChangeBack}
                  listType="picture-card"
                  fileList={fileBack}
                  onPreview={handlePreview}
                  maxCount={1}
                >
                  {fileBack.length < 1 && <UploadButton />}
                </Upload>
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            label="Số CCCD/HC"
            name="identification_number"
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập số CCCD hoặc Hộ chiếu!'
              },
              {
                pattern: new RegExp(
                  `(${cccdRegex.source})|(${passportRegex.source})`
                ),
                message:
                  'Định dạng không hợp lệ! (CCCD: 12 số, HC: 1 chữ + 7 số)'
              }
            ]}
          >
            <Input
              placeholder="Nhập số CCCD / HC"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'identification_number',
                    value: e.target.value?.trim()
                  }
                ])
              }}
              autoComplete="off"
              inputMode="none"
            />
          </Form.Item>
          <Form.Item
            label="Chức danh"
            name="user_role"
            rules={[
              {
                message: 'Vui lòng chọn chức danh',
                required: true
              }
            ]}
          >
            <Select
              style={{ width: '100%' }}
              placeholder="Chọn chức danh"
              onChange={() => {
                const role = form.getFieldValue('user_role')

                if (role === 'CEO') {
                  setDepartmentField({
                    name: 'department_manage',
                    mode: 'multiple'
                  })
                  form.setFieldsValue({ department_manage: null })
                } else {
                  setDepartmentField({ name: 'department', mode: undefined })
                  form.setFieldsValue({ department: null })
                }
              }}
            >
              {OPTIONS_ROLE.map((item, idx) => {
                return (
                  <Option key={idx} value={item.value}>
                    {item.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item
            name={departmentField.name}
            label="Sàn"
            rules={[
              {
                message: 'Vui lòng chọn sàn',
                required: true
              }
            ]}
          >
            <Select
              style={{ width: '100%' }}
              placeholder="Chọn sàn"
              mode={departmentField.mode}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(
                  option?.children || ''
                ).toLowerCase()
                return optionValue.includes(inputValue)
              }}
              onChange={(value) => {
                if (value && !Array.isArray(value)) {
                  getPermissionByDepartment(value)
                  form.setFieldsValue({ permission_id: '' })
                } else {
                  // getPermissionAll() // Ví dụ khi cần reset permission list
                }
              }}
            >
              {listDepartment?.list?.map((item, idx) => {
                return (
                  <Option key={idx} value={item.id}>
                    {item.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          {['DIRECTOR', 'SALE_MANAGER'].includes(userRole) ? (
            <Form.Item
              label="Luồng tin"
              name="product_type"
              labelCol={{ span: 6 }}
              rules={[
                {
                  required: true,
                  message: 'Vui lòng chọn luồng tin'
                }
              ]}
            >
              <Select style={{ width: '100%' }} placeholder="Chọn luồng tin">
                {OPTIONS_PRODUCT_TYPE.map((item, idx) => {
                  return (
                    <Option key={idx} value={item.value}>
                      {item.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          ) : null}
          {userRole !== 'CEO' && (
            <Form.Item
              label="Quyền"
              name="permission_id"
              rules={[
                {
                  required: true,
                  message: 'Vui lòng chọn quyền'
                }
              ]}
            >
              <Select
                style={{ width: '100%' }}
                placeholder="Chọn tên quyền"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const inputValue = removeVietnameseTones(input).toLowerCase()
                  const optionValue = removeVietnameseTones(
                    option?.children || ''
                  ).toLowerCase()
                  return optionValue.includes(inputValue)
                }}
              >
                {listRole &&
                  listRole.map((item, idx) => {
                    return (
                      <Option key={idx} value={item.id}>
                        {item.name}
                      </Option>
                    )
                  })}
              </Select>
            </Form.Item>
          )}

          <Form.Item
            label="Ngày sinh"
            name="date_of_birth"
            // rules={[
            //   {
            //     required: true,
            //     message: ''
            //   }
            // ]}
          >
            <DatePicker
              placeholder="Nhập ngày sinh"
              format="DD/MM/YYYY"
              style={{ width: '100%' }}
            />
          </Form.Item>
          {mode == ACTION_MODE.ADD && (
            <>
              <Form.Item
                label="Mật khẩu"
                name="password"
                rules={[
                  {
                    required: mode === ACTION_MODE.ADD ? true : false,
                    message: 'Vui lòng nhập mật khẩu!'
                  },
                  {
                    pattern: passwordRegex,
                    message:
                      'Mật khẩu phải có ít nhất 8 ký tự, chữ hoa, chữ thường, số và ký tự đặc biệt!'
                  }
                ]}
              >
                <Input.Password
                  placeholder="Nhập mật khẩu"
                  autoComplete="new-password"
                  inputMode="none"
                />
              </Form.Item>
              <Form.Item
                label="Nhập lại mật khẩu"
                name="re_enter_password"
                dependencies={['password']}
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const password = getFieldValue('password')
                      if (mode === ACTION_MODE.ADD && password) {
                        if (!value) {
                          return Promise.reject(
                            new Error('Vui lòng nhập lại mật khẩu!')
                          )
                        }
                        if (value !== password) {
                          return Promise.reject(
                            new Error('Mật khẩu nhập lại không khớp!')
                          )
                        }
                      }
                      return Promise.resolve()
                    }
                  })
                ]}
              >
                <Input.Password
                  placeholder="Nhập lại mật khẩu"
                  autoComplete="off"
                  inputMode="none"
                />
              </Form.Item>
            </>
          )}
        </Form>
        <Modal
          open={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={() => setPreviewVisible(false)}
        >
          <img alt="preview" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </ModalCustom>
      <ModalCustom
        title={`Lịch sử xem số điện thoại${
          showPhoneHistoryUser?.name ? ` - ${showPhoneHistoryUser.name}` : ''
        }`}
        visible={visibleShowPhoneHistory}
        centered
        width={900}
        footer={[]}
        onCancel={() => {
          setVisibleShowPhoneHistory(false)
          setShowPhoneHistoryUser(null)
        }}
      >
        <Space style={{ marginBottom: 16 }} wrap>
          <DatePicker.RangePicker
            format="DD/MM/YYYY"
            value={
              showPhoneHistoryDate?.length === 2 ? showPhoneHistoryDate : null
            }
            onChange={(value) => setShowPhoneHistoryDate(value || [])}
          />
          <Button
            type="primary"
            onClick={() =>
              fetchShowPhoneHistory(showPhoneHistoryUser, showPhoneHistoryDate)
            }
          >
            Tìm kiếm
          </Button>
        </Space>
        <Tabs
          items={[
            {
              key: 'posts',
              label: `Tin đăng (${showPhoneHistoryData.posts.length})`,
              children: (
                <TableField
                  loading={showPhoneHistoryLoading}
                  columns={showPhoneHistoryColumns.posts}
                  data={showPhoneHistoryData.posts}
                  rowKey={(record, index) => record?.id || index}
                  pagination={false}
                />
              )
            },
            {
              key: 'requests',
              label: `Tin yêu cầu (${showPhoneHistoryData.requests.length})`,
              children: (
                <TableField
                  loading={showPhoneHistoryLoading}
                  columns={showPhoneHistoryColumns.requests}
                  data={showPhoneHistoryData.requests}
                  rowKey={(record, index) => record?.id || index}
                  pagination={false}
                />
              )
            },
            {
              key: 'customerData',
              label: `Data dữ liệu KH (${showPhoneHistoryData.customerData.length})`,
              children: (
                <TableField
                  loading={showPhoneHistoryLoading}
                  columns={showPhoneHistoryColumns.customerData}
                  data={showPhoneHistoryData.customerData}
                  rowKey={(record, index) => record?.id || index}
                  pagination={false}
                />
              )
            },
            {
              key: 'recruiment',
              label: `Tuyển dụng (${showPhoneHistoryData.recruiment.length})`,
              children: (
                <TableField
                  loading={showPhoneHistoryLoading}
                  columns={showPhoneHistoryColumns.recruiment}
                  data={showPhoneHistoryData.recruiment}
                  rowKey={(record, index) => record?.id || index}
                  pagination={false}
                />
              )
            }
          ]}
        />
      </ModalCustom>
      <ChangePasswordModal
        visible={visibleChangePass}
        onCancel={() => setVisibleChangePass(false)}
        onChangePassword={handleChangePassword}
      />
      <ModalAddMoney
        visible={visibleChangeMoney}
        onCancel={() => setVisibleMoney(false)}
        onAddMoney={onAddMoney}
      />

      <ModalExtensionComunity
        visible={visibleExtension}
        onCancel={() => setVisibleExtension(false)}
        onFinish={onPaymentPackage}
        detailUser={detailUser}
      />
      <ModalConfirm />
    </div>
  )
}

export default UserManagement
